import { IRootState } from '@/store/state';
import { GetterTree, Getter } from 'vuex';
import { IAssociateUserState } from './state';
import { PaginationMeta, AssociateUser, AssociateUserFilter } from '../types';

/**
 * --------------------------------------------------
 *	User Getters
 * --------------------------------------------------
 **/
export const AssociateUserGetters: IAssociateUserGetters = {
  associateUsers: (state: IAssociateUserState): AssociateUser[] =>
    state.associateUsers,
  associateUserPaginationMeta: (state: IAssociateUserState): PaginationMeta =>
    state.associateUserPaginationMeta,
  appliedAssociateUserFilter: (
    state: IAssociateUserState
  ): AssociateUserFilter => state.appliedFilter
};

/**
 * --------------------------------------------------
 *	User Getters Interface
 * --------------------------------------------------
 **/
export interface IAssociateUserGetters
  extends GetterTree<IAssociateUserState, IRootState> {
  associateUsers(state: IAssociateUserState): AssociateUser[];
  associateUserPaginationMeta(state: IAssociateUserState): PaginationMeta;
  appliedAssociateUserFilter(state: IAssociateUserState): AssociateUserFilter;
}
